//@ts-nocheck
export function setColorVarsFromAttributes(): void {
    const elements: NodeListOf<HTMLElement> = document.querySelectorAll(`.accordion-three`);

    if(!elements) return

    elements.forEach((el: HTMLElement) => {
        const bgColor = el.getAttribute('data-bg');
        const textColor = el.getAttribute('data-text');
        
        updateColours(el, bgColor, textColor);
    });
}

function updateColours(el, bgColor, textColor) {
    const accordions: NodeListOf<HTMLElement> = el.querySelectorAll(`.accordion-three__accordion`);

    accordions.forEach((accordion: HTMLElement) => {
        const heading: HTMLHeadingElement = accordion.querySelector(`.accordion-three__accordion-heading`);
        const btn: HTMLElement = accordion.querySelector(`.accordion-three__accordion-btn`);

        if (bgColor) {
            accordion.style.backgroundColor = bgColor;
            accordion.style.borderColor = bgColor;
            heading.style.color = textColor;
            btn.style.color = textColor;
        }
    });
}